// src/components/Footer.jsx — ZENZZZ OFFICIAL COLORS
import React from 'react';
import { Link, useNavigate  } from 'react-router-dom';
//import moonIcon from '../assets/images/moon-icon-white.png';

const Footer = () => {

    // Inside the Footer component
    const navigate = useNavigate();

    const handleScrollToSection = (sectionId) => {
        if (window.location.pathname === '/') {
            // Already on homepage → just scroll
            document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
        } else {
            // Not on homepage → go home first, then scroll
            navigate('/');
            setTimeout(() => {
                document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
            }, 300); // small delay to let page load
        }
    };

    return (
        <footer className="zenzzz-footer">
            <div className="footer-top">
                <div className="container">
                    <div className="footer-grid">
                        {/* Column 1 */}
                        <div className="footer-col">
                            <h4>Quick Links</h4>
                            <ul>
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/checkout">Shop</Link></li>
                                <li><Link to="/faq">FAQ</Link></li>
                                <li><Link to="/contact">Contact</Link></li>
                                <li>
                                    <button
                                        onClick={() => handleScrollToSection('blog')}
                                        className="footer-link"
                                    >
                                        Blog
                                    </button>
                                </li>
                            </ul>
                        </div>

                        {/* Column 2 */}
                        <div className="footer-col">
                            <h4>Our Policies</h4>
                            <ul>
                                <li><Link to="/privacy">Privacy Policy</Link></li>
                                <li><Link to="/terms">Terms of Service</Link></li>
                                <li><Link to="/refund">Refund Policy</Link></li>
                            </ul>
                        </div>

                        {/* Column 3 */}
                        <div className="footer-col">
                            <h4>Contact</h4>
                            <p>
                                <a href="mailto:support@zenzzz.online">support@zenzzz.online </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Subscribe */}
            <div className="footer-bottom">
                <div className="container">
                    <div className="subscribe-area">

                        <div className="subscribe-text">
                            <h4>Subscribe</h4>
                            <p>Stay updated on the latest at ZenZzZ</p>
                            <form className="subscribe-form">
                                <input type="email" placeholder="your@email.com" required />
                                <button type="submit">Sign up</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;